var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcItalic = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.022 4H19a1 1 0 1 1 0 2h-4.246l-3.428 12H15a1 1 0 0 1 0 2H5a1 1 0 1 1 0-2h4.246l3.428-12H9a1 1 0 1 1 0-2h5.021"
})));
export default SvgIcItalic;